module.exports = __webpack_public_path__ + "static/media/launchVideoLoop.852c2ace.mp4";